import React, { useState, useEffect } from "react";

import CheckBoxOutlineBlankSharpIcon from "@mui/icons-material/CheckBoxOutlineBlankSharp";
import ShowChartSharpIcon from "@mui/icons-material/ShowChartSharp";
import LocationOnSharpIcon from "@mui/icons-material/LocationOnSharp";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import APIHelper from "@giscon/utils.api-helper-esri";
import layerStore from "@giscon/utils.layer-store";

export default function GraphicSelectorListItem({
  graphic,
  onHover,
  onMouseOut,
  onClick,
  isEditorSelected,
  nls,
}) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (open) {
      onHover();
    } else {
      onMouseOut();
    }
  }, [open]);
  const attributes = APIHelper.getAttributes(graphic);
  const layer = layerStore.layerManager.getOriginLayer(graphic);
  let displayField = layer ? layer.displayField : null;
  /* if we select from geometries(graphics without layer or symbol or attributes) */
  const selectedText = isEditorSelected
    ? `${nls.graphicSelectorDeselect}`
    : `${nls.graphicSelectorSelect}`;

  const keys = attributes ? Object.keys(attributes) : [];
  const getDisplayValue = (name, value) => {
    if (value === undefined || value === null || `${value}`.trim() === "") {
      return "<null>";
    }
    if (value === false) {
      return "false";
    }
    if (value === true) {
      return "true";
    }
    if (layer && layer.maps.field[name]) {
      const { domain } = layer.maps.field[name];
      if (domain && domain.codedValues) {
        return domain.getName(value);
      }
    }
    return value;
  };

  let typeIcon = <LocationOnSharpIcon />;
  if (APIHelper.getGeometryType(graphic) === "polygon") {
    typeIcon = <CheckBoxOutlineBlankSharpIcon />;
  } else if (APIHelper.getGeometryType(graphic) === "polyline") {
    typeIcon = <ShowChartSharpIcon />;
  }
  // Behandlung, falls das Displayfield ein Alias ist
  const fields = APIHelper.getFields(layer);
  if (fields) {
    fields.forEach((i) => {
      if (i.alias === displayField && i.name in attributes) {
        displayField = i.name;
      }
    });
  }
  return (
    <Accordion
      style={{ marginBottom: 10 }}
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        style={{ background: "#E9E9E9" }}
        onMouseEnter={!open && onHover}
        onMouseLeave={!open && onMouseOut}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {typeIcon}
          <div style={{ marginLeft: 5, width: "100%" }}>
            {`${(layer && attributes[displayField]) ||
              nls.graphicSelectorDefaultListItem
              } (${layer ? layer.id : ""})`}
          </div>
          <Tooltip title={nls.graphicSelectorTT}>
            <Button
              onClick={onClick}
              variant="contained"
              color={isEditorSelected ? "secondary" : "primary"}
              style={{
                marginLeft: "5px",
                padding: "5px 15px",
                overflow: "hidden",
                display: "block",
                minWidth: "fit-content",
              }}
            // startIcon={typeIcon}
            >
              {`${selectedText}`}
            </Button>
          </Tooltip>
        </div>
      </AccordionSummary>

      <AccordionDetails style={{ background: "#E9E9E9" }}>
        <div style={{ display: "block" }}>
          {keys
            .map((key) => {
              if (layer.maps.field[key] || !layer) {
                return (
                  <div style={{ marginTop: 3, display: "block" }}>
                    {layer.maps.alias[key] || key}
                    {": "}
                    {getDisplayValue(key, attributes[key])}
                  </div>
                );
              }
              return null;
            })
            .filter((i) => i !== null)}
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
